const getOrganizationChildProject = (organizations, orgID) => {
    let eligibleChildProjects = organizations.filter(
        (obj) => obj.parent_organization_id === orgID && obj.role && obj.is_project,
    );
    let defaultProject = eligibleChildProjects.filter((obj) => obj.name === 'Default');
    if (defaultProject.length > 0) {
        return defaultProject[0].id;
    } else if (eligibleChildProjects.length > 0) {
        return eligibleChildProjects[0].id;
    }
    return null;
};

export const getProjectIdByOrgName = (organizations, orgName) => {
    let defaultOrganization = organizations.filter(
        (obj) => !obj.is_project && obj.name.toLowerCase() === orgName.toLowerCase(),
    );
    if (defaultOrganization.length > 0) {
        let defaultOrgID = defaultOrganization[0].id;
        if (defaultOrganization[0].role) {
            return defaultOrgID;
        } else {
            return getOrganizationChildProject(organizations, defaultOrgID);
        }
    }
    return null;
};

export const getFirstEligibleProjectId = (organizations) => {
    let eligibleOrganizations = organizations.filter((obj) => obj.role);
    if (eligibleOrganizations.length > 0) {
        return eligibleOrganizations[0].id;
    }
    return null;
};
